export default "__VITE_ASSET__C7dGf3Qm__"